export const listSlides = [
  {
    bg: "/images/homeSlides/5.jpg", 
    title: { pt: "Ilumine seu jardim, terraço e espaços exteriores",
  en: "Light up your garden, terrace, and outdoor spaces",
  es: "Ilumina tu jardín, terraza y espacios exteriores",
  fr: "Illuminez votre jardin, terrasse et espaces extérieurs",
  it: "Illumina il tuo giardino, terrazza e spazi esterni",
  de: "Beleuchten Sie Ihren Garten, Ihre Terrasse und Außenbereiche",
  zh: "点亮您的花园、露台和室外空间"},
    text: { pt: "Aqui o que não falta é variedade na escolha de iluminação exterior pelo melhor preço e eficiência. A Iluminação exterior LED é perfeita se procuramos iluminar o jardim, a fachada, um terraço exterior, um alpendre ou qualquer outra área exterior da nossa casa.",
  en: "Here you will find plenty of options for outdoor lighting at the best price and efficiency. LED outdoor lighting is perfect if we want to illuminate the garden, the facade, an outdoor terrace, a porch, or any other outdoor area of our home.",
  es: "Aquí no falta variedad en la elección de iluminación exterior al mejor precio y eficiencia. La iluminación exterior LED es perfecta si queremos iluminar el jardín, la fachada, una terraza exterior, un porche u otra zona exterior de nuestra casa.",
  fr: "Ici, vous trouverez une grande variété de choix en matière d'éclairage extérieur au meilleur prix et avec une grande efficacité. L'éclairage extérieur LED est parfait si nous voulons illuminer le jardin, la façade, une terrasse extérieure, un porche ou tout autre espace extérieur de notre maison.",
  it: "Qui non manca la varietà nella scelta dell’illuminazione esterna al miglior prezzo ed efficienza. L’illuminazione LED da esterno è perfetta se vogliamo illuminare il giardino, la facciata, una terrazza esterna, un portico o qualsiasi altra area esterna della nostra casa.",
  de: "Hier finden Sie eine große Auswahl an Außenbeleuchtung zum besten Preis und mit hoher Effizienz. LED-Außenbeleuchtung ist perfekt, wenn wir den Garten, die Fassade, eine Außenterrasse, eine Veranda oder einen anderen Außenbereich unseres Hauses beleuchten möchten.",
  zh: "在这里，您可以找到丰富的户外照明选择，价格实惠且高效。LED户外照明非常适合照亮花园、立面、室外露台、门廊或家中的任何其"},
  },
  {
    bg: "/images/homeSlides/2.jpg",
    title: {    pt: "Iluminação pública",
    en: "Public Lighting",
    es: "Iluminación pública",
    fr: "Éclairage public",
    it: "Illuminazione pubblica",
    de: "Straßenbeleuchtung",
    zh: "公共照明"},
    text:  {
    pt: "A iluminação pública é muito mais do que luz, é essencial para a qualidade de vida nos centros urbanos. Postes, luminárias, lâmpadas, cabos elétricos permitem a distribuição da luz de forma uniforme e eficiente. Conosco pode-se confiar em opções para garantir o funcionamento adequado de serviços essenciais, como transporte público, serviços de emergência e comércio noturno.",
    en: "Public lighting is much more than light; it is essential for quality of life in urban centers. Poles, luminaires, lamps, and electric cables ensure the uniform and efficient distribution of light. With us, you can rely on options that guarantee the proper functioning of essential services, such as public transport, emergency services, and nighttime commerce.",
    es: "La iluminación pública es mucho más que luz, es esencial para la calidad de vida en los centros urbanos. Postes, luminarias, lámparas y cables eléctricos permiten la distribución de la luz de manera uniforme y eficiente. Con nosotros puede confiar en opciones que garanticen el correcto funcionamiento de servicios esenciales como transporte público, servicios de emergencia y comercio nocturno.",
    fr: "L'éclairage public est bien plus que de la lumière, il est essentiel à la qualité de vie dans les centres urbains. Poteaux, luminaires, lampes et câbles électriques permettent une distribution uniforme et efficace de la lumière. Avec nous, vous pouvez compter sur des solutions qui garantissent le bon fonctionnement des services essentiels tels que les transports publics, les services d'urgence et le commerce nocturne.",
    it: "L’illuminazione pubblica è molto più che luce, è essenziale per la qualità della vita nei centri urbani. Pali, lampioni, lampade e cavi elettrici consentono una distribuzione uniforme ed efficiente della luce. Con noi puoi contare su soluzioni che garantiscono il corretto funzionamento di servizi essenziali come trasporto pubblico, servizi di emergenza e commercio notturno.",
    de: "Straßenbeleuchtung ist viel mehr als nur Licht; sie ist für die Lebensqualität in städtischen Zentren unverzichtbar. Masten, Leuchten, Lampen und Stromkabel ermöglichen eine gleichmäßige und effiziente Lichtverteilung. Mit uns können Sie auf Lösungen vertrauen, die das reibungslose Funktionieren von wichtigen Diensten wie öffentlichem Verkehr, Notfalldiensten und Nachtgeschäft gewährleisten.",
    zh: "公共照明不仅仅是光，它对于城市中心的生活质量至关重要。灯杆、灯具、灯泡和电缆确保光线的均匀高效分布。有了我们，您可以信赖能够保障公共交通、紧急服务和夜间商业等基本服务正常运行的解决方案。"
  },
  },
  {
    bg: "/images/homeSlides/3.jpg",
    title: { pt: "Crie uma “atmosfera”",en: "Create an 'atmosphere'",es: "Crea una 'atmósfera'", fr: "Créez une 'atmosphère'",it: "Crea un'“atmosfera”",de: "Schaffen Sie eine “Atmosphäre“",zh: "营造一种“氛围”"
  },
    text:  {
    pt: "A escolha de luminárias e fontes de luz oportunas pode transformar um espaço simples ou sem identidade em um ambiente acolhedor, cativante e criativo, deixando uma impressão muito mais marcante para quem está no local.",
    en: "The choice of appropriate lighting fixtures and light sources can transform a simple or characterless space into a welcoming, captivating, and creative environment, leaving a much stronger impression on those present.",
    es: "La elección de luminarias y fuentes de luz adecuadas puede transformar un espacio simple o sin identidad en un ambiente acogedor, cautivador y creativo, dejando una impresión mucho más marcada en quienes están en el lugar.",
    fr: "Le choix de luminaires et de sources lumineuses appropriés peut transformer un espace simple ou sans identité en un environnement accueillant, captivant et créatif, laissant une impression beaucoup plus marquante pour ceux qui s'y trouvent.",
    it: "La scelta di lampade e fonti luminose adeguate può trasformare uno spazio semplice o privo di identità in un ambiente accogliente, affascinante e creativo, lasciando un’impressione molto più forte a chi vi si trova.",
    de: "Die Wahl geeigneter Leuchten und Lichtquellen kann einen schlichten oder identitätslosen Raum in eine einladende, faszinierende und kreative Umgebung verwandeln und bei den Anwesenden einen viel stärkeren Eindruck hinterlassen.",
    zh: "选择合适的灯具和光源，可以将一个简单或缺乏个性的空间转变为温馨、迷人且富有创意的环境，给身处其中的人留下更深刻的印象。"
  },
  },
];

export const rdesignImgs = [
  {
    id: 1,
    image: "/images/rdesign/1.jpg",
  },
  {
    id: 2,
    image: "/images/rdesign/2.jpg",
  },
  {
    id: 3,
    image: "/images/rdesign/3.jpg",
  },
  {
    id: 4,
    image: "/images/rdesign/4.jpg",
  },
  {
    id: 5,
    image: "/images/rdesign/5.jpg",
  },
  {
    id: 6,
    image: "/images/rdesign/6.jpg",
  },
];

export const areas = [
  {
    id: 1,
    name: { pt: "Iluminação Decorativa", en: "Decorative Lighting", es: "Iluminación Decorativa", fr: "Éclairage Décoratif", it: "Illuminazione Decorativa",de: "Dekorative Beleuchtung",zh: "装饰照明"},
    subTitle: { pt: "Damos forma à luz.", en: "We shape light.", es: "Damos forma a la luz.",fr: "Nous donnons forme à la lumière.",it: "Diamo forma alla luce.", de: "Wir geben dem Licht Form.", zh: "我们赋予光以形态。" },
    description:  {
      pt: "Nós entendemos a importância da escolha dos produtos certos na criação de um ambiente aconchegante e dar vida ao seu espaço exterior.",
      en: "We understand the importance of choosing the right products to create a cozy atmosphere and bring life to your outdoor space.",
      es: "Entendemos la importancia de elegir los productos adecuados para crear un ambiente acogedor y dar vida a tu espacio exterior.",
      fr: "Nous comprenons l'importance de choisir les bons produits pour créer une atmosphère chaleureuse et donner vie à votre espace extérieur.",
      it: "Comprendiamo l'importanza di scegliere i prodotti giusti per creare un ambiente accogliente e dare vita al tuo spazio esterno.",
      de: "Wir verstehen die Bedeutung der richtigen Produktauswahl, um eine gemütliche Atmosphäre zu schaffen und Ihrem Außenbereich Leben einzuhauchen.",
      zh: "我们理解选择合适的产品在营造舒适氛围和为您的户外空间增添活力方面的重要性。"
    },
    image: "/images/areas/1.jpg",
    usos: {pt: ["Áreas de lazer", "Jardins", "Fachadas de edifícios", "Interiores"],
      en: ["Leisure areas", "Gardens", "Building facades", "Interiors"],
      es: ["Áreas de ocio", "Jardines", "Fachadas de edificios", "Interiores"],
      fr: ["Espaces de loisirs", "Jardins", "Façades de bâtiments", "Intérieurs"],
      it: ["Aree ricreative", "Giardini", "Facciate di edifici", "Interni"],
      de: ["Freizeitbereiche", "Gärten", "Gebäudefassaden", "Innenräume"],
      zh: ["休闲区", "花园", "建筑外立面", "室内"]}
  },
  {
    id: 2,
    name:{ pt: "Domótica", en: "Home Automation", es: "Domótica",fr: "Domotique",it: "Domotica",de: "Hausautomation", zh: "智能家居" },
    subTitle: { pt: "Um ecossistema inteligente", en: "A smart ecosystem", es: "Un ecosistema inteligente", fr: "Un écosystème intelligent", it: "Un ecosistema intelligente", de: "Ein intelligentes Ökosystem", zh: "智能生态系统" },
    description: {
      pt: "Sistema avançado que inclui placas inteligentes, controles e atuadores, sensores e painéis de pulsadores sem fio.",
      en: "Advanced system that includes smart boards, controls and actuators, sensors, and wireless push-button panels.",
      es: "Sistema avanzado que incluye placas inteligentes, controles y actuadores, sensores y paneles de pulsadores inalámbricos.",
      fr: "Système avancé comprenant des cartes intelligentes, des commandes et actionneurs, des capteurs et des panneaux à boutons-poussoirs sans fil.",
      it: "Sistema avanzato che include schede intelligenti, controlli e attuatori, sensori e pannelli a pulsanti wireless.",
      de: "Fortschrittliches System mit intelligenten Steuerungen, Aktoren, Sensoren und drahtlosen Taster-Panels.",
      zh: "先进系统，包括智能板、控制器和执行器、传感器以及无线按钮面板。"
    },
    image: "/images/areas/2.jpg",
    usos: {
      pt: ["Residências", "Escritórios", "Edifícios inteligentes", "Hotéis"],
      en: ["Residences", "Offices", "Smart buildings", "Hotels"],
      es: ["Residencias", "Oficinas", "Edificios inteligentes", "Hoteles"],
      fr: ["Résidences", "Bureaux", "Bâtiments intelligents", "Hôtels"],
      it: ["Residenze", "Uffici", "Edifici intelligenti", "Hotel"],
      de: ["Wohnhäuser", "Büros", "Intelligente Gebäude", "Hotels"],
      zh: ["住宅", "办公室", "智能建筑", "酒店"]
    }
  },
  {
    id: 3,
    name:{ pt: "Iluminação Industrial", en: "Industrial Lighting",es: "Iluminación Industrial", fr: "Éclairage Industriel",it: "Illuminazione Industriale", de: "Industrielle Beleuchtung",zh: "工业照明" },
    subTitle: { pt: "Resistência e clareza", en: "Resistance and clarity", es: "Resistencia y claridad", fr: "Résistance et clarté",
      it: "Resistenza e chiarezza",de: "Widerstandsfähigkeit und Klarheit", zh: "坚固与清晰"},
    description: {
      pt: "Opções de iluminação altamente resistentes à prova de explosão, poeira e gás para iluminar as usinas de energia, docas de carga, estaleiros etc.",
      en: "Highly resistant lighting options that are explosion-proof, dust-proof, and gas-proof to illuminate power plants, loading docks, shipyards, and more.",
      es: "Opciones de iluminación altamente resistentes a prueba de explosiones, polvo y gas para iluminar plantas de energía, muelles de carga, astilleros, etc.",
      fr: "Options d'éclairage hautement résistantes, antidéflagrantes, anti-poussière et anti-gaz pour éclairer les centrales électriques, quais de chargement, chantiers navals, etc.",
      it: "Opzioni di illuminazione altamente resistenti, a prova di esplosione, polvere e gas, per illuminare centrali elettriche, banchine di carico, cantieri navali, ecc.",
      de: "Hochbeständige Beleuchtungsoptionen, explosionssicher, staub- und gasdicht, zur Beleuchtung von Kraftwerken, Verladerampen, Werften usw.",
      zh: "高强度照明选择，具备防爆、防尘、防气体功能，用于电厂、装卸码头、造船厂等。"
    },
    usos: {
      pt: ["Usinas de energia", "Docas de carga", "Estaleiros", "Fábricas", "Armazéns"],
      en: ["Power plants", "Loading docks", "Shipyards", "Factories", "Warehouses"],
      es: ["Plantas de energía", "Muelles de carga", "Astilleros", "Fábricas", "Almacenes"],
      fr: ["Centrales électriques", "Quais de chargement", "Chantiers navals", "Usines", "Entrepôts"],
      it: ["Centrali elettriche", "Banchine di carico", "Cantieri navali", "Fabbriche", "Magazzini"],
      de: ["Kraftwerke", "Laderampen", "Werften", "Fabriken", "Lagerhäuser"],
      zh: ["发电厂", "装卸码头", "造船厂", "工厂", "仓库"]
    },
    image: "/images/areas/3.jpg",
  },
  {
    id: 4,
    name:{pt: "Mobilidade",en: "Mobility",es: "Movilidad",fr: "Mobilité",it: "Mobilità",de: "Mobilität", zh: "出行"},
    subTitle: { pt: "A recarga para cada trabalho",  en: "Charging for every job", es: "La recarga para cada trabajo", fr: "La recharge pour chaque besoin", it: "La ricarica per ogni esigenza",de: "Aufladen für jede Aufgabe",
    zh: "为每个需求提供充电" },
    description: {
      pt: "Soluções completas e seguras para a gestão de recargas de veículos elétricos, garantindo eficiência e controle.",
      en: "Complete and safe solutions for managing electric vehicle charging, ensuring efficiency and control.",
      es: "Soluciones completas y seguras para la gestión de recargas de vehículos eléctricos, garantizando eficiencia y control.",
      fr: "Des solutions complètes et sûres pour la gestion de la recharge des véhicules électriques, garantissant efficacité et contrôle.",
      it: "Soluzioni complete e sicure per la gestione della ricarica dei veicoli elettrici, garantendo efficienza e controllo.",
      de: "Komplette und sichere Lösungen für das Management von Ladungen von Elektrofahrzeugen, mit Effizienz und Kontrolle.",
      zh: "提供完整且安全的电动车充电管理解决方案，确保高效与可控。"
    },
    usos: {
      pt: ["Estacionamentos públicos", "Garagens residenciais", "Postos de serviço", "Empresas de logística"],
      en: ["Public parking lots", "Residential garages", "Service stations", "Logistics companies"],
      es: ["Aparcamientos públicos", "Garajes residenciales", "Estaciones de servicio", "Empresas de logística"],
      fr: ["Parkings publics", "Garages résidentiels", "Stations-service", "Entreprises de logistique"],
      it: ["Parcheggi pubblici", "Garage residenziali", "Stazioni di servizio", "Aziende di logistica"],
      de: ["Öffentliche Parkplätze", "Wohnungsgaragen", "Tankstellen", "Logistikunternehmen"],
      zh: ["公共停车场", "住宅车库", "加油站", "物流公司"]
    },
    image: "/images/areas/4.jpg",
  },
  {
    id: 5,
    name:{ pt: "Iluminação Solar", en: "Solar Lighting", es: "Iluminación Solar", fr: "Éclairage Solaire",it: "Illuminazione Solare",de: "Solarbeleuchtung", zh: "太阳能照明"},
    subTitle: { pt: "Sustentabilidade em cada raio", en: "Sustainability in every ray", es: "Sostenibilidad en cada rayo", fr: "Durabilité dans chaque rayon", it: "Sostenibilità in ogni raggio",
    de: "Nachhaltigkeit in jedem Strahl",zh: "每一缕光的可持续性" },
    description:{pt: "Tecnologia de ponta que utiliza a energia solar para iluminação, unindo economia, eficiência e responsabilidade ambiental.",
    en: "Cutting-edge technology that uses solar energy for lighting, combining savings, efficiency, and environmental responsibility.",
    es: "Tecnología de vanguardia que utiliza energía solar para iluminación, uniendo ahorro, eficiencia y responsabilidad ambiental.",
    fr: "Une technologie de pointe qui utilise l'énergie solaire pour l'éclairage, alliant économie, efficacité et responsabilité environnementale.",
    it: "Tecnologia all'avanguardia che utilizza l'energia solare per l'illuminazione, unendo risparmio, efficienza e responsabilità ambientale.",
    de: "Spitzentechnologie, die Solarenergie für Beleuchtung nutzt und Einsparungen, Effizienz und ökologische Verantwortung vereint.",
    zh: "利用太阳能照明的尖端技术，结合节能、高效与环保责任。"},
    usos: {
    pt: ["Ruas e rodovias", "Parques e jardins", "Áreas rurais", "Espaços públicos"],
    en: ["Streets and highways", "Parks and gardens", "Rural areas", "Public spaces"],
    es: ["Calles y carreteras", "Parques y jardines", "Zonas rurales", "Espacios públicos"],
    fr: ["Rues et routes", "Parcs et jardins", "Zones rurales", "Espaces publics"],
    it: ["Strade e autostrade", "Parchi e giardini", "Aree rurali", "Spazi pubblici"],
    de: ["Straßen und Autobahnen", "Parks und Gärten", "Ländliche Gebiete", "Öffentliche Räume"],
    zh: ["街道和公路", "公园和花园", "农村地区", "公共空间"]
  },
    image: "/images/areas/5.jpg",
  },
  {
    id: 6,
    name:{
      pt: "Material elétrico",
      en: "Electrical Material",
      es: "Material eléctrico",
      fr: "Matériel électrique",
      it: "Materiale elettrico",
      de: "Elektromaterial",
      zh: "电气材料"
    },
    subTitle:  {
      pt: "A base de todo projeto",
      en: "The foundation of every project",
      es: "La base de todo proyecto",
      fr: "La base de tout projet",
      it: "La base di ogni progetto",
      de: "Die Grundlage jedes Projekts",
      zh: "每个项目的基础"
    },
    description:  {
      pt: "Produtos essenciais para a distribuição e proteção de energia, assegurando segurança e desempenho em qualquer instalação.",
      en: "Essential products for energy distribution and protection, ensuring safety and performance in any installation.",
      es: "Productos esenciales para la distribución y protección de energía, garantizando seguridad y rendimiento en cualquier instalación.",
      fr: "Produits essentiels pour la distribution et la protection de l'énergie, assurant sécurité et performance dans toute installation.",
      it: "Prodotti essenziali per la distribuzione e protezione dell'energia, garantendo sicurezza e prestazioni in qualsiasi installazione.",
      de: "Wesentliche Produkte für Energieverteilung und -schutz, die Sicherheit und Leistung in jeder Installation gewährleisten.",
      zh: "能源分配和保护的基本产品，确保任何安装中的安全性和性能。"
    },
    usos: {
      pt: ["Construções residenciais", "Prédios comerciais", "Instalações industriais", "Infraestrutura urbana"],
      en: ["Residential buildings", "Commercial buildings", "Industrial installations", "Urban infrastructure"],
      es: ["Construcciones residenciales", "Edificios comerciales", "Instalaciones industriales", "Infraestructura urbana"],
      fr: ["Constructions résidentielles", "Bâtiments commerciaux", "Installations industrielles", "Infrastructure urbaine"],
      it: ["Costruzioni residenziali", "Edifici commerciali", "Impianti industriali", "Infrastrutture urbane"],
      de: ["Wohngebäude", "Gewerbegebäude", "Industrieanlagen", "Städtische Infrastruktur"],
      zh: ["住宅建筑", "商业建筑", "工业设施", "城市基础设施"]
    },
    image: "/images/areas/6.jpg",
  },
    {
    id: 7,
    name:{
      pt: "Iluminação Técnica",
      en: "Technical Lighting",
      es: "Iluminación Técnica",
      fr: "Éclairage Technique",
      it: "Illuminazione Tecnica",
      de: "Technische Beleuchtung",
      zh: "技术照明"
    },
    subTitle:  {
      pt: "Promovendo clareza e variedade",
      en: "Promoting clarity and variety",
      es: "Promoviendo claridad y variedad",
      fr: "Favoriser clarté et variété",
      it: "Promuovere chiarezza e varietà",
      de: "Fördert Klarheit und Vielfalt",
      zh: "提升清晰度与多样性"
    },
    description: {
      pt: "Diversas opções para projetar a iluminação geral e variadas cores para deixar o seu ambiente marcante.",
      en: "Various options to design general lighting and different colors to make your environment stand out.",
      es: "Varias opciones para diseñar la iluminación general y diferentes colores para destacar tu ambiente.",
      fr: "Diverses options pour concevoir l'éclairage général et différentes couleurs pour rendre votre environnement marquant.",
      it: "Diverse opzioni per progettare l'illuminazione generale e vari colori per rendere il tuo ambiente distintivo.",
      de: "Verschiedene Optionen zur Gestaltung der Allgemeinbeleuchtung und unterschiedliche Farben, um Ihre Umgebung hervorzuheben.",
      zh: "多种选择用于设计总体照明，并提供不同颜色，使您的环境更具特色。"
    },
    usos: {
      pt: ["Residências", "Escritórios", "Hospitais", "Escolas", "Grandes superfícies"],
      en: ["Residences", "Offices", "Hospitals", "Schools", "Large surfaces"],
      es: ["Residencias", "Oficinas", "Hospitales", "Escuelas", "Grandes superficies"],
      fr: ["Résidences", "Bureaux", "Hôpitaux", "Écoles", "Grandes surfaces"],
      it: ["Residenze", "Uffici", "Ospedali", "Scuole", "Grandi superfici"],
      de: ["Wohnhäuser", "Büros", "Krankenhäuser", "Schulen", "Großflächen"],
      zh: ["住宅", "办公室", "医院", "学校", "大型空间"]
    },
    image: "/images/areas/7.jpg",
  },
    {
    id: 8,
    name:{
      pt: "Iluminação para comércio",
      en: "Commercial Lighting",
      es: "Iluminación para comercio",
      fr: "Éclairage Commercial",
      it: "Illuminazione Commerciale",
      de: "Beleuchtung für den Handel",
      zh: "商业照明"
    },
    subTitle: {
      pt: "O destaque do seu negócio",
      en: "The highlight of your business",
      es: "El destaque de tu negocio",
      fr: "La mise en valeur de votre entreprise",
      it: "Il punto di forza della tua attività",
      de: "Das Highlight Ihres Geschäfts",
      zh: "凸显您的业务"
    },
    description:  {
      pt: "Soluções que valorizam produtos e ambientes comerciais, criando uma atmosfera atraente e otimizando a experiência do cliente.",
      en: "Solutions that enhance products and commercial spaces, creating an attractive atmosphere and optimizing customer experience.",
      es: "Soluciones que realzan productos y entornos comerciales, creando una atmósfera atractiva y optimizando la experiencia del cliente.",
      fr: "Des solutions qui valorisent les produits et les espaces commerciaux, créant une atmosphère attrayante et optimisant l'expérience client.",
      it: "Soluzioni che valorizzano prodotti e ambienti commerciali, creando un'atmosfera attraente e ottimizzando l'esperienza del cliente.",
      de: "Lösungen, die Produkte und Geschäftsräume aufwerten, eine attraktive Atmosphäre schaffen und das Kundenerlebnis optimieren.",
      zh: "提升产品和商业空间的解决方案，营造吸引人的氛围并优化客户体验。"
    },
    usos:  {
      pt: ["Lojas de varejo", "Restaurantes e bares", "Shoppings centers", "Galerias de arte"],
      en: ["Retail stores", "Restaurants and bars", "Shopping centers", "Art galleries"],
      es: ["Tiendas minoristas", "Restaurantes y bares", "Centros comerciales", "Galerías de arte"],
      fr: ["Magasins de détail", "Restaurants et bars", "Centres commerciaux", "Galeries d'art"],
      it: ["Negozi al dettaglio", "Ristoranti e bar", "Centri commerciali", "Gallerie d'arte"],
      de: ["Einzelhandelsgeschäfte", "Restaurants und Bars", "Einkaufszentren", "Kunstgalerien"],
      zh: ["零售店", "餐厅和酒吧", "购物中心", "艺术画廊"]
    },
    image: "/images/areas/8.jpg",
  },
  {
    id: 9,
    name:'CCTV Vídeo Vigilância',
    subTitle:  {
      pt: "Olhos que protegem",
      en: "Eyes that protect",
      es: "Ojos que protegen",
      fr: "Des yeux qui protègent",
      it: "Occhi che proteggono",
      de: "Schützende Augen",
      zh: "守护的眼睛"
    },
    description: {
      pt: "Sistemas avançados de vídeo vigilância para monitoramento contínuo, garantindo a segurança de pessoas e patrimônio.",
      en: "Advanced video surveillance systems for continuous monitoring, ensuring the safety of people and property.",
      es: "Sistemas avanzados de videovigilancia para monitoreo continuo, garantizando la seguridad de personas y patrimonio.",
      fr: "Systèmes avancés de vidéosurveillance pour un suivi continu, garantissant la sécurité des personnes et des biens.",
      it: "Sistemi avanzati di videosorveglianza per il monitoraggio continuo, garantendo la sicurezza di persone e beni.",
      de: "Fortschrittliche Videoüberwachungssysteme für kontinuierliche Überwachung, die Sicherheit von Menschen und Eigentum gewährleisten.",
      zh: "先进的视频监控系统，用于持续监控，确保人员和财产安全。"
    },
    usos: {
      pt: ["Residências", "Empresas e indústrias", "Bancos e instituições financeiras", "Espaços públicos"],
      en: ["Residences", "Companies and industries", "Banks and financial institutions", "Public spaces"],
      es: ["Residencias", "Empresas e industrias", "Bancos e instituciones financieras", "Espacios públicos"],
      fr: ["Résidences", "Entreprises et industries", "Banques et institutions financières", "Espaces publics"],
      it: ["Residenze", "Aziende e industrie", "Banche e istituzioni finanziarie", "Spazi pubblici"],
      de: ["Wohnhäuser", "Unternehmen und Industrien", "Banken und Finanzinstitute", "Öffentliche Räume"],
      zh: ["住宅", "公司与工业", "银行和金融机构", "公共空间"]
    },
    image: "/images/areas/9.jpg",
  },
];

export const details = [
  {
    id: 1,
    name: { pt: "EQUIPA DIVERSIFICADA ", en: "A DIVERSE TEAM", es: "EQUIPO DIVERSIFICADO", fr: "ÉQUIPE DIVERSIFIÉE", it: "TEAM DIVERSIFICATO",de: "VIELFÄLTIGES TEAM",zh: "多元化团队"},
    icon: 'fa-solid fa-users-gear',
    description:  {
      pt: "Contamos com uma equipa de profissionais qualificados especializados em iluminação e com visão para atender às necessidades específicas do seu projeto.",
      en: "We have a team of qualified professionals specialising in lighting and with the vision to meet the specific needs of your project.",
      es: "Contamos con un equipo de profesionales cualificados especializados en iluminación y con visión para satisfacer las necesidades específicas de su proyecto.",
      fr: "Nous disposons d'une équipe de professionnels qualifiés spécialisés dans l'éclairage et dotés d'une vision permettant de répondre aux besoins spécifiques de votre projet.",
      it: "Abbiamo un team di professionisti qualificati specializzati nell'illuminazione e con una visione in grado di soddisfare le esigenze specifiche del tuo progetto.",
      de: "Wir verfügen über ein Team qualifizierter Fachleute, die auf Beleuchtung spezialisiert sind und die spezifischen Anforderungen Ihres Projekts erfüllen können.",
      zh: " 我们拥有一支由专业照明专家组成的团队，他们具备满足您项目特定需求的远见卓识。"
    },
  },
    {
    id: 2,
    name: { pt: "EXCELÊNCIA NO SERVIÇO", en: "SERVICE EXCELLENCE", es: "EXCELENCIA EN EL SERVICIO", fr: "EXCELLENCE DU SERVICE", it: "ECCELLENZA NEL SERVIZIO",de: "EXZELLENZ IM SERVICE",zh: "卓越服务"},
    icon: 'ffi fi-ts-drafting-compass',
    description:  {
      pt: `Garantimos ao consumidor produtos analisados meticulosamente em termos de proteção, eficiência e proteção do ambiente.`,
      en: `We guarantee consumers products that have been meticulously analysed in terms of safety, efficiency and environmental protection.`,
      es: `Garantizamos al consumidor productos analizados meticulosamente en términos de protección, eficiencia y protección del medio ambiente.`,
      fr: `Nous garantissons au consommateur des produits minutieusement analysés en termes de protection, d'efficacité et de respect de l'environnement.`,
      it: `Garantiamo al consumatore prodotti accuratamente analizzati in termini di protezione, efficienza e tutela dell'ambiente.`,
      de: `Wir garantieren dem Verbraucher Produkte, die hinsichtlich Sicherheit, Effizienz und Umweltschutz sorgfältig geprüft wurden.`,
      zh: `我们向消费者保证，所有产品均经过严格检测，确保其安全性、高效性和环保性。`
    },
  },
    {
    id: 3,
    name: { pt: "Gestão de Stock Eficaz", en: "Effective Stock Management", es: "Gestión eficaz del stock", fr: "Gestion efficace des stocks", it: "Gestione efficace delle scorte",de: "Effiziente Lagerverwaltung",zh: "高效库存管理"},
    icon: 'fi fi-ts-supplier-alt',
    description:  {
      pt: `Mantemos um vasto stock de materiais de iluminação e elétricos, garantindo que você sempre tenha o que precisa, quando precisa.`,
      en: `We maintain a vast stock of lighting and electrical materials, ensuring that you always have what you need, when you need it.`,
      es: `Disponemos de un amplio stock de materiales de iluminación y eléctricos, lo que garantiza que siempre tendrá lo que necesita, cuando lo necesita.`,
      fr: `Nous disposons d'un vaste stock de matériel d'éclairage et électrique, afin que vous ayez toujours ce dont vous avez besoin, quand vous en avez besoin.`,
      it: `Disponiamo di un vasto assortimento di materiali per l'illuminazione e l'impianto elettrico, garantendovi di avere sempre ciò che vi serve, quando vi serve.`,
      de: `Wir führen ein umfangreiches Sortiment an Beleuchtungs- und Elektromaterialien, damit Sie immer das haben, was Sie brauchen, wenn Sie es brauchen.`,
      zh: `我们拥有大量照明和电气材料的库存，确保您随时都能获得所需物品。`
    },
  },
];
{/*Dispomos de um grande stock, por sabermos o quão importante é mantermos a linha de fornecimento permanente aos nossos parceiros. */}
{/*Com uma rede de parceiros bem implementada, pode encontrar uma grande variedade de produtos de referência de qualidade, tecnologia e inovação, alem de marcas próprias 
  focadas em tecnologia LED, que garantem um produto mais eficiente, duradouro e também muito estilo*/}
    {/*
    <div className="row">
      <div className="form">
        <form action="">
          <input type="text" placeholder="Email here..." />
          <button>
            <i className="fa fa-paper-plane" />
          </button>
        </form>
      </div>
    </div>
    */}
{/**Fale com um especialista<i class= "fi fi-tr-user-headset"></i> */}
{/**Veja seu orçamento <i class="fi fi-ts-checklist-task-budget"></i> */}
{/**Comunicação <i class="fi fi-tr-referral-user"></i> */}
{/**Logistica <i class="fi fi-tr-analyse-alt"></i> */}
